module.exports = __webpack_public_path__ + "static/media/home_healthcare_document.b2054cd4.png";